
import { useNewsLoader } from "./hooks/useNewsLoader";
import { useArticleCreation } from "./hooks/useArticleCreation";
import { useArticleManagement } from "./hooks/useArticleManagement";

export const useNewsManagement = () => {
  const { articles, setArticles } = useNewsLoader();
  
  const { 
    newArticle, 
    setNewArticle, 
    handleAddArticle 
  } = useArticleCreation({ articles, setArticles });
  
  const { 
    handleDeleteArticle, 
    handleTogglePublic 
  } = useArticleManagement({ articles, setArticles });

  return {
    articles,
    newArticle,
    setNewArticle,
    handleAddArticle,
    handleDeleteArticle,
    handleTogglePublic
  };
};
